namespace TabAurous.OMS {
    export namespace RawMaterialMasterService {
        export const baseUrl = 'OMS/RawMaterialMaster';

        export declare function Create(request: Serenity.SaveRequest<RawMaterialMasterRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<RawMaterialMasterRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<RawMaterialMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<RawMaterialMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetParentList(request: ProductRequest, onSuccess?: (response: Serenity.ListResponse<RawMaterialMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "OMS/RawMaterialMaster/Create",
            Update = "OMS/RawMaterialMaster/Update",
            Delete = "OMS/RawMaterialMaster/Delete",
            Retrieve = "OMS/RawMaterialMaster/Retrieve",
            List = "OMS/RawMaterialMaster/List",
            GetParentList = "OMS/RawMaterialMaster/GetParentList"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'GetParentList'
        ].forEach(x => {
            (<any>RawMaterialMasterService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
